<div class="alertas" *ngIf="telaPrincipal; else modalRoteiro" >
  <div  class="container-alerta-principal">
    <div class="d-flex justify-content-between mb-2">
      <span class="font-weight-bold tipo-alerta">{{roteiroAlerta.TipoAlerta}}</span>
      <app-data-horario class="info-roteiro-alerta" [data]="roteiroAlerta.DTAlerta"></app-data-horario>
    </div>
    <div class="d-flex mb-2">
      <p class="me-1">Roteiro: </p>
      <p class="font-weight-bold">{{roteiroAlerta.NumeroRoteiro}}</p>
      <p class="ms-4 me-1">Motorista:</p>
      <p class="font-weight-bold">{{roteiroAlerta.NomeMotorista}} ({{roteiroAlerta.PlacaVeiculo}})</p>
    </div>
    <div class="d-flex justify-content-end">
      <button data-bs-toggle="modal" data-bs-target="#modalPrincipal" (click)="abrirMaparoteiroAlerta()" class="visu-mapa me-2">Visualizar no mapa</button>
      <div *ngIf="roteiroAlerta.IdStatus == null; else abrirOcorrencia">
        <app-botao-primario titulo="Criar ocorrência" (onPress)="ocorrencia()" ></app-botao-primario>
      </div>      
        <ng-template #abrirOcorrencia>
          <app-botao-primario titulo="Abrir ocorrência" (click)="ocorrencia()" ></app-botao-primario>
        </ng-template> 
    </div> 
    </div> 
</div>    



<ng-template #modalRoteiro>
  <div class="alertas2">

    <div class="container-alerta-secundario mt-2">
      <div class="d-flex justify-content-between align-items-center">
        <span class="tit-principal"> {{roteiroAlerta.TipoAlerta}} </span>
        <span class="codigo-oc" ><img src="assets/img/tag-fill.svg" alt=""  *ngIf="roteiroAlerta.CodigoOcorrencia !== null" ><b>{{roteiroAlerta.CodigoOcorrencia}}</b></span> 
        <div class="nao-visto" *ngIf="!roteiroAlerta.Visualizado"></div>
      </div>
      <div class="d-flex justify-content-between mb-3">
        <app-data-horario class="info-roteiro-alerta" [data]="roteiroAlerta.DTAlerta"></app-data-horario>
        <span class="info-roteiro-alerta" *ngIf="roteiroAlerta.IdStatus == 1 || roteiroAlerta.IdStatus == 2 ">Oc. em andamento</span>
        <span class="info-roteiro-alerta" *ngIf="roteiroAlerta.IdStatus == 3">Oc. finalizada</span>
      </div>
     
      <div class="mb-2 d-flex justify-content-end" >
        <button *ngIf="roteiroAlerta.IdStatus == null; else abrirOcorrencia" class="criar-oc" (click)="ocorrencia()">Criar ocorrência</button>
        <ng-template #abrirOcorrencia>
            <button (click)="ocorrencia()" class="criar-oc">Abrir ocorrência</button>
        </ng-template> 
      </div>
    </div> 
  </div>
</ng-template>

